import React from "react";
import { Modal }    from "react-bootstrap";
import CloseBtn     from "assets/icons/Close-1.svg";
import ShieldIcon   from "assets/images/withdrawal-success.svg";
import "./Withdraw.scss";

const WithdrawSuccessModal = ({ show, onDone, data }) => {
  return (
    <Modal className="withdraw-success-modal" size="lg" show={ show } onHide={ onDone } backdrop="static" centered>
      <Modal.Header className="p-0">
        <button type="button" className="close close-button position-relative pb-0" onClick={ onDone }>
          <img src={ CloseBtn } alt="modal-close" className="w-30" />
        </button>
      </Modal.Header>

      <Modal.Body>
        <img src={ ShieldIcon } alt="success" className="success-shield" />
        <div className="success-title">Withdrawal Request Submitted.</div>
        <div className="success-text">Your request has been submitted successfully.</div>

        <div className="success-rows">
          <div className="summary-row">
            <span className="summary-label">Amount</span>
            <span className="summary-value">{ data?.amount }</span>
          </div>
          <div className="summary-row">
            <span className="summary-label">Account No.</span>
            <span className="summary-value">{ data?.accountNo }</span>
          </div>
          <div className="summary-row">
            <span className="summary-label">Bank Account</span>
            <span className="summary-value">{ data?.bankAccount }</span>
          </div>
          <div className="summary-row">
            <span className="summary-label">Date &amp; Time</span>
            <span className="summary-value">{ data?.dateTime }</span>
          </div>
          <div className="summary-row">
            <span className="summary-label">Reference No.</span>
            <span className="summary-value">{ data?.referenceNo }</span>
          </div>
        </div>

        <p className="success-note">You will be notified once the withdrawal is processed.</p>
      </Modal.Body>

      <Modal.Footer className="d-block">
        <button type="button" className="btn btn-coral" onClick={ onDone }>Done</button>
      </Modal.Footer>
    </Modal>
  );
};

export default WithdrawSuccessModal;
